import { g as getFocusableElements } from './getFocusableElements-73f83f90-0ab4a5e4.js';

function focusFirstElement(element) {
  const focusableEls = getFocusableElements(element);
  if (focusableEls.length > 0) {
    focusableEls[0].focus();
  }
}

export { focusFirstElement as f };
//# sourceMappingURL=focusFirstElement-1606ea52-51c97026.js.map
